<template>
  <login-card-shell
    title="ระบบเข้าสู่ระบบ"
    subtitle="ข้าราชการครูและบุคลากรทางการศึกษา"
    username-hint="Username: รหัสบัตรประชาชน"
    password-hint="ลืมรหัสผ่าน? กดปุ่มด้านล่าง"
    notice-text="ครั้งแรกเข้าใช้งาน/ลืมรหัสผ่าน ติดต่อผู้ดูแลระบบ หรือกด 'ลืมรหัสผ่าน'"
    thaid-notice-text="บัญชีนี้ต้องยืนยันตัวตนเพิ่มเติมผ่าน ThaiID หลังกรอกรหัสผ่าน (ออกให้โดยกรมการปกครอง กระทรวงมหาดไทย)"
    logo-icon-src="https://cdn.lordicon.com/shcfcebj.json"
    theme-color-start="#1976d2"
    theme-color-end="#0d47a1"
    :dialog-value="dialogLogin"
    @update:dialogValue="dialogLogin = $event"
    :snackbar-value="dialog"
    @update:snackbarValue="dialog = $event"
    :snackbar-msg="dialog_msg"
    :loading="loading"
    :lockout-message="lockoutMessage"
    @submit="userLogin"
  >
    <template v-slot:extra-action>
      <div class="d-flex justify-center flex-wrap">
        <reset-password-dialog person-type="personnel" />
        <usage-guide-dialog person-type="personnel" />
      </div>
    </template>

    <v-form ref="form" lazy-validation>
      <v-text-field
        color="primary"
        prepend-icon="mdi-account"
        name="login"
        label="ชื่อผู้ใช้งาน : รหัสบัตรประชาชน"
        type="text"
        v-model="id_card"
        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
        rounded
        outlined
        class="enhanced-input mb-4"
      ></v-text-field>

      <v-text-field
        color="primary"
        name="password"
        label="รหัสผ่าน"
        prepend-icon="mdi-lock-outline"
        id="password"
        v-model="p_word"
        rounded
        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        outlined
        class="enhanced-input"
        hint="จำรหัสผ่านไม่ได้? กด 'ลืมรหัสผ่าน' ด้านล่าง"
        persistent-hint
      ></v-text-field>
    </v-form>
  </login-card-shell>
</template>

<script>
import LoginCardShell from "./LoginCardShell.vue";
import resetPasswordDialog from "./ResetPasswordDialog.vue";
import usageGuideDialog from "./UsageGuideDialog.vue";

const VALID_STATUSES = [
  "teacher", "se_director", "director", "S", "38", "3801", "3802", "3803", "C"
];

export default {
  components: { LoginCardShell, resetPasswordDialog, usageGuideDialog },
  data() {
    return {
      ApiKey: "HRvec2021",
      show1: false,
      dialogLogin: false,
      id_card: "",
      p_word: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      lockoutMessage: ""
    };
  },
  methods: {
    async userLogin() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.lockoutMessage = "";
      try {
        let result = await this.$http.post("login.php?crud=user", {
          id_card: this.id_card,
          p_word: this.p_word
        });

        if (result.data.user_status === "Locked") {
          const minutes = Math.ceil((result.data.retry_after || 0) / 60);
          this.lockoutMessage = `ล็อกอินผิดเกินกำหนด กรุณารออีกประมาณ ${minutes} นาที`;
          return;
        }

        if (result.data.user_status === "NeedThaidVerify") {
          // รหัสผ่านถูกต้องแล้ว แต่ยังไม่ออก session จนกว่าจะยืนยันตัวตนผ่าน ThaiID สำเร็จ —
          // ต้อง redirect ทั้งหน้า (ไม่ใช่ XHR) เพราะเป็น cross-origin ไปหน้า DOPA
          this.dialog_msg = "กำลังนำท่านไปยืนยันตัวตนทางดิจิทัลผ่าน ThaiID (ออกให้โดยกรมการปกครอง กระทรวงมหาดไทย) กรุณาสแกน QR Code หรือยืนยันผ่านแอป ThaID ในขั้นตอนถัดไป...";
          this.dialog = true;
          window.location.href = result.data.authorize_url;
          return;
        }

        if (result.data.user_status) {
          let user = result.data;
          user.system_lock = false;
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem(
            "force_password_change",
            user.must_change_password ? "1" : "0"
          );

          if (VALID_STATUSES.includes(user.user_status)) {
            this.dialogLogin = false;
            this.dialog = true;
            this.dialog_msg = "เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนหน้า...";
            setTimeout(() => {
              this.$router.push("/user");
            }, 1500);
          } else {
            localStorage.clear();
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          }
        } else {
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
        }
      } catch (error) {
        this.dialog = true;
        this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}
</style>
